export enum UpdatePlanEnum {
  DISCARD = 'DISCARD',
  SAVE = 'SAVE'
}
